export default __webpack_public_path__ + "static/media/membership-nft-season-02.fe5aaba7.png";